// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+Op5W","content":"styles_content__gJXnP","headerColumn":"styles_headerColumn__y9zQv"};